<template>
	<div
		class="g-block-title-center-break g-block-title-padding"
		:class="{
			'g-block-title-center-break--edit': editable,
			'is-active': editable && active,
			'g-block-title-center-break--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-center-break__row">
			<span class="g-block-title-center-break__line" :style="{ background: lightColor }"></span>
			<RichTextEditable
				v-if="editable"
				class="g-block-title-center-break__text"
				fit-content
				:style="{ color: themeColor }"
				:model-value="data.content"
				placeholder="请输入标题"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-title-center-break__text"
				:style="{ color: themeColor }"
				v-html="data.content || ''"
			></div>
			<span class="g-block-title-center-break__line" :style="{ background: lightColor }"></span>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { singleTitleMixin } from '../shared/singleTitleMixin.js';

	export default {
		name: 'GBlockTitleCenterBreak',
		components: { RichTextEditable },
		mixins: [singleTitleMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	.g-block-title-center-break {
		.title-block-edit-shell();
	}

	.g-block-title-center-break__row {
		display: flex;
		align-items: center;
		gap: 16px;
	}

	.g-block-title-center-break__line {
		flex: 1;
		height: 1px;
		min-width: 12px;
	}

	.g-block-title-center-break__text {
		flex-shrink: 0;
		font-size: 22px;
		font-weight: 700;
		line-height: 1.3;
		text-align: center;
		:deep(.g-rich-text-editable__content) { min-height: unset; padding: 0; font-weight: 700; }
	}

	.g-block-title-center-break--h5 {
		.g-block-title-center-break__row { gap: 0.32rem; }
		.g-block-title-center-break__text { font-size: 0.44rem; }
		.g-block-title-center-break__line { height: 0.02rem; }
	}
</style>
